// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileHeader_container__A_yXV","logo":"MobileHeader_logo__2MRWy","digital":"MobileHeader_digital__2Mlk1","switch":"MobileHeader_switch__1F7Ys"};